import { render } from "./App.vue?vue&type=template&id=e3a46c22"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/song/Desktop/pro/homePage/沙漠传说/desertlegendhomepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__